import { render, staticRenderFns } from "./SelectedMenu.vue?vue&type=template&id=5a1f78e8&scoped=true&"
import script from "./SelectedMenu.vue?vue&type=script&lang=js&"
export * from "./SelectedMenu.vue?vue&type=script&lang=js&"
import style0 from "./SelectedMenu.vue?vue&type=style&index=0&id=5a1f78e8&scoped=true&lang=scss&"
import style1 from "./SelectedMenu.vue?vue&type=style&index=1&id=5a1f78e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1f78e8",
  null
  
)

export default component.exports